
import {type UseMutationConfig, useMutation} from 'react-relay'
import type {useSubmitErrorFeedbackMutation as TSubmitErrorFeedbackMutation} from '../__generated__/useSubmitErrorFeedbackMutation.graphql'

const mutation = __relay_useSubmitErrorFeedbackMutation

















const useSubmitErrorFeedbackMutation = () => {
  const [commit, submitting] = useMutation<TSubmitErrorFeedbackMutation>(mutation)
  const execute = (config: UseMutationConfig<TSubmitErrorFeedbackMutation>) => {
    return commit({...config})
  }
  return [execute, submitting] as const
}

export default useSubmitErrorFeedbackMutation

import __relay_useSubmitErrorFeedbackMutation from '~/__generated__/useSubmitErrorFeedbackMutation.graphql';
